
/**
 * 결제 주기
 */
export type PlanChangeOptionsResponseUpgradeOptionsItemBillingCycle = typeof PlanChangeOptionsResponseUpgradeOptionsItemBillingCycle[keyof typeof PlanChangeOptionsResponseUpgradeOptionsItemBillingCycle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanChangeOptionsResponseUpgradeOptionsItemBillingCycle = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  ONE_TIME: 'ONE_TIME',
} as const;
